<script>
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default {
  name: "TimeInput",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    mb: {
      type: Number,
      default: 3
    },
  },
  emits: ['update:modelValue'],
  methods: {
    updateValue(event) {
      let value = event.target.value

      if (value.length === 4 && !value.includes(':')) {
        const time = dayjs(value, 'HHmm', true)
        if (time.isValid())
          value = event.target.value = time.format('HH:mm');
      }

      this.$emit('update:modelValue', value);
    },
    setCurrentTime() {
      this.$emit('update:modelValue', dayjs().format('HH:mm'));
    }
  }
}
</script>

<template>
  <div :class="'input-group col-4 w45 pr-0 mb-'+ mb">
    <div class="input-group-prepend">
      <label
          :for="inputId"
          class="input-group-text pointer"
          style="min-width:auto"
          @click.prevent="setCurrentTime">Z</label>
    </div>
    <input
        :id="inputId"
        :value="modelValue"
        class="form-control form-control-lg"
        placeholder="HHmm / HH:mm"
        pattern="(?:\d{4}|(?:[01]\d|2[0-3]):[0-5]\d)"
        @input="updateValue"/>
  </div>
</template>

<style scoped>

</style>